import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableMultiSelect } from '@shared/components/SearchableMultiSelect';
import type { TranscriberResponseDto } from '@shared/services/apiService/apiService';
import {
  formatTranscriberLabel,
  transcriberMatchesProviderQuery,
} from '@shared/utils/transcriberDisplay';

type SelectTranscribersInputProps = {
  transcribers: TranscriberResponseDto[] | undefined;
  selectedIds: string[];
  onChange: (nextIds: string[]) => void;
  disabled?: boolean;
  portalDropdown?: boolean;
};

function transcriberMatchesQuery(item: TranscriberResponseDto, query: string) {
  const label = formatTranscriberLabel(item).toLowerCase();
  return (
    label.includes(query) ||
    transcriberMatchesProviderQuery(item, query) ||
    (item.language ?? '').toLowerCase().includes(query)
  );
}

export const SelectTranscribersInput: React.FC<SelectTranscribersInputProps> = ({
  transcribers,
  selectedIds,
  onChange,
  disabled,
  portalDropdown = false,
}) => {
  const { t } = useTranslation();

  return (
    <SearchableMultiSelect
      items={transcribers}
      selectedIds={selectedIds}
      onChange={onChange}
      disabled={disabled}
      portalDropdown={portalDropdown}
      listboxId="select-transcribers-listbox"
      getLabel={formatTranscriberLabel}
      matchesQuery={transcriberMatchesQuery}
      placeholder={t('superAdminMainPage.companies.selectTranscribersInput.placeholder')}
      emptyLabel={t('superAdminMainPage.companies.selectTranscribersInput.empty')}
      getRemoveLabel={(name) =>
        t('superAdminMainPage.companies.selectTranscribersInput.removeTranscriber', { name })
      }
    />
  );
};
